<template>
  <div>
    <div
        v-if="isLoading"
        id="loading-bg__cus"
        class="fs-loading__cus"
        style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
      "
    ></div>
    <div class="name-show">{{ formName }}</div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <new-model-form
                ref="newRequestFormData"
                :pycType="pycType"
                @onContinue="onContinue"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-row v-if="isContinue">
      <b-col class="text-align-right" cols="12" style="padding-right: 80px">
        <b-button class="btn-icon p-inline-30" variant="danger" @click="onSaveData"
        >Lưu
        </b-button
        >
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {BButton, BCard, BCol, BRow} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import NewModelForm from "../../components/newModelForm/newModelForm.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    NewModelForm,
  },
  props: {
    pycType: {
      type: String,
      default: "",
    },
  },
  async mounted() {
  },
  computed: {},
  watch: {},
  methods: {
    async onSaveData() {
      const data = this.$refs["newRequestFormData"].getNewData();

      if (!data) return;

      this.isLoading = true;

      const rs = await useJwt.post(`createPYC`, data);
      if (rs.data.code === 200) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tạo phiếu yêu cầu thành công",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        setTimeout(() => {
          this.$router.push("/noti-request/home");
        }, 300);
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: rs.data.message,
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
      this.isLoading = false;
    },
    onContinue(name) {
      this.isContinue = !this.isContinue;
      this.formName = name;
    },
  },
  data() {
    return {
      isCreateForm: false,
      isContinue: false,
      listBrand: [],
      formName: "",
      isLoading: false,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}

.p-inline-30 {
  padding-inline: 30px !important;
}

.name-show {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: large;
  font-weight: 600;
  margin-bottom: 20px;
}

.fs-loading__cus {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #111;
  opacity: 0.7;
  z-index: 1000;
}

.fs-loading__cus::after {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;
  border-left: 3px solid #e91c27;
  border-top: 3px solid #e91c27;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -webkit-animation: rotate360 1.5s infinite;
  animation: rotate360 1.5s infinite linear;
  z-index: 1000;
}

#loading-bg__cus {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: block;
  position: absolute;
  z-index: 99999;
}
</style>
